import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-06',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-06.component.html',
  styleUrls: []
})
export class Article06Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Quanto dinheiro preciso para começar em leilão imobiliário? | Casato Brasil',
    description: 'Veja quais custos considerar antes de participar de um leilão imobiliário, além do lance, e como planejar melhor o capital necessário.'
  };
}
